import { render } from "./product-carousel-media.vue?vue&type=template&id=1f5bfcd2"
import script from "./product-carousel-media.vue?vue&type=script&lang=js"
export * from "./product-carousel-media.vue?vue&type=script&lang=js"

import "./product-carousel-media.vue?vue&type=style&index=0&id=1f5bfcd2&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__